var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80.284,
    height: 71.364,
    viewBox: "0 0 80.284 71.364",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80.324,6H8.96v8.92H80.324Zm4.46,44.6v-8.92l-4.46-22.3H8.96L4.5,41.682V50.6H8.96V77.364h44.6V50.6H71.4V77.364h8.92V50.6ZM44.642,68.443H17.881V50.6H44.642Z",
    transform: "translate(-4.5 -6)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStore);
export default __webpack_public_path__ + "static/media/icon-store.02040627b8cd96914aa6a424e1fa7cec.svg";
export { ForwardRef as ReactComponent };